import type { MealType, Recipe } from './types.js';

export interface RecipeFilter {
  search?: string;
  meal_type?: MealType | '';
  fridge_ingredients?: number[];
}

export function filterRecipes(recipes: Recipe[], f: RecipeFilter): Recipe[] {
  const mealType: MealType | '' = f.meal_type ?? '';
  const fridgeIds = f.fridge_ingredients ?? [];
  const rawSearch = typeof f.search === 'string' ? f.search.trim() : '';
  const search = rawSearch.toLowerCase();
  const hasSearch = search.length > 0;
  const hasFridge = fridgeIds.length > 0;

  const out: Recipe[] = [];
  for (const r of recipes) {
    if (mealType !== '' && r.meal_type !== mealType) continue;
    if (hasFridge && !r.ingredients.some((l) => fridgeIds.includes(l.ingredient_id))) continue;
    if (hasSearch) {
      const titleMatch = r.title.toLowerCase().includes(search);
      const ingMatch = r.ingredients.some((l) => l.name.toLowerCase().includes(search));
      if (!titleMatch && !ingMatch) continue;
    }
    out.push(r);
  }
  return out;
}
